import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('AddTemporaryLicenseDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'licenseInfo',
    addTemporaryLicenseDialogCtrl,
  ]);

function addTemporaryLicenseDialogCtrl($element, $http, appUrls, flySvc, close, licenseInfo) {
  var vm = this;
  vm.price = licenseInfo.temporaryLicensePrice;
  const today = moment()
    .utc()
    .startOf('day');
  vm.months = 1;
  vm.license = {
    beginDate: moment.utc(today).toDate(),
    endDate: moment
      .utc(today)
      .add(1, 'months')
      .toDate(),
    isTemporary: true,
    userId: null,
  };
  vm.durationText = '';

  vm.beginDateOptions = {
    minDate: moment.utc(today).toDate(),
  };
  vm.endDateOptions = {
    minDate: moment
      .utc(today)
      .add(1, 'months')
      .toDate(),
    maxDate: moment
      .utc(today)
      .add(7, 'months')
      .toDate(),
  };

  vm.datesChanged = function() {
    if (vm.license.beginDate) {
      vm.endDateOptions.minDate = moment
        .utc(vm.license.beginDate)
        .add(1, 'months')
        .toDate();
      vm.endDateOptions.maxDate = moment
        .utc(vm.license.beginDate)
        .add(6, 'months')
        .toDate();
    }
    if (vm.license.endDate) {
      if (vm.license.endDate > vm.endDateOptions.maxDate) {
        vm.license.endDate = vm.endDateOptions.maxDate;
      }
      if (vm.license.endDate < vm.endDateOptions.minDate) {
        vm.license.endDate = vm.endDateOptions.minDate;
      }
      vm.months = moment
        .utc(vm.license.endDate)
        .diff(moment.utc(vm.license.beginDate), 'months', true);
    }
  };
  vm.datesChanged();
  vm.addMonths = function(nr) {
    vm.license.endDate = moment
      .utc(vm.license.endDate)
      .add(nr, 'months')
      .toDate();
    vm.datesChanged();
  };
  vm.setDuration = function(nr) {
    vm.license.endDate = moment
      .utc(vm.license.beginDate)
      .add(nr, 'months')
      .toDate();
    vm.datesChanged();
  };
  vm.save = function() {
    vm.saving = true;
    var model = {
      ...vm.license,
      beginDate: vm.license.beginDate.ISO(),
      endDate: vm.license.endDate.ISO(),
    };

    $http({
      method: 'post',
      url: appUrls.api + '/api/License/TemporaryLicense',
      data: model,
    })
      .then(function(response) {
        var result = response.data;
        $element.modal('hide');
        close(result, 500);
      })
      .catch(function(error) {
        flySvc.error(error.code, error.parameters);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
